import React, { useEffect, useState } from 'react';
import FeedbackPrompt from './FeedbackPrompt';
import useDialog from '../hooks/useDialog';
import { useLanguage } from '../contexts/LanguageContext';
import { trackEvent } from '../utils/analytics';

/** "Send feedback" from the Options menu (opened via the wl:open-feedback event). */
export default function FeedbackModal() {
    const [open, setOpen] = useState(false);
    const { language, t } = useLanguage();
    const dialogRef = useDialog(open, () => setOpen(false));

    useEffect(() => {
        const handler = () => { setOpen(true); trackEvent('Feedback Shown', { context: 'menu' }); };
        window.addEventListener('wl:open-feedback', handler);
        return () => window.removeEventListener('wl:open-feedback', handler);
    }, []);

    if (!open) return null;
    return (
        <div className="modal-overlay-base modal-overlay" onClick={() => setOpen(false)}>
            <div className="modal-content-base login-modal" data-modal-scrollable ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby="fb-modal-title" onClick={e => e.stopPropagation()}>
                <button className="close-button" onClick={() => setOpen(false)} aria-label={t('common.close')}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <div className="modal-header">
                    <h2 id="fb-modal-title">{t('feedback.modal.title')}</h2>
                    <p style={{ opacity: 0.8, marginTop: '0.25rem' }}>{t('feedback.modal.lead')}</p>
                </div>
                <FeedbackPrompt context="menu" lang={language} onDone={() => setOpen(false)} />
            </div>
        </div>
    );
}
